import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,	
	portal: 'SP',
};

export type SPCandidateHistoryCreqEditLocNames =
	| 'SPCandidateHistoryCreqEditLabelFactor'
	| 'SPCandidateHistoryCreqEditHintErrorPoints'
	| 'SPCandidateHistoryCreqEditNumericErrorPoints'
	| 'SPCandidateHistoryCreqEditNumericErrorWithUnits'
	| 'SPCandidateHistoryCreqEditHintErrorWithUnits'
	| 'SPCandidateHistoryCreqEditHintMinPoints'
	| 'SPCandidateHistoryCreqEditHintMinPointsWithUnits';

export const spCandidateHistoryCreqEditLocs: LocDefs<SPCandidateHistoryCreqEditLocNames> = {
	SPCandidateHistoryCreqEditLabelFactor: {
		defaultValue: 'Factor',
		description: 'Label for: Factor.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Factor',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
	SPCandidateHistoryCreqEditHintErrorPoints: {
		defaultValue: 'Points * Factor must be less than or equal to ',
		description: 'Hint/error message for: Points.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Hint Error Points',
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
	SPCandidateHistoryCreqEditNumericErrorPoints: {
		defaultValue: 'Points must be a positive whole number.',
		description: 'Error message for: Points.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Numeric Error Points',
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
	SPCandidateHistoryCreqEditNumericErrorWithUnits: {
		defaultValue: 'must be a positive whole number.',
		description: 'Error message suffix for factor units.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Numeric Error With Units',
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
	SPCandidateHistoryCreqEditHintErrorWithUnits: {
		defaultValue: '* Factor must be less than or equal to',
		description: 'Error message suffix for factor units with max points.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Hint Error With Units',
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
	SPCandidateHistoryCreqEditHintMinPoints: {
		defaultValue: 'Points * Factor must be at least ',
		description: 'Hint/error message for minimum points requirement.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Hint Error Min Points',
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
	SPCandidateHistoryCreqEditHintMinPointsWithUnits: {
		defaultValue: '* Factor must be at least',
		description: 'Hint/error message suffix for factor units with minimum points.',
		displayPath: 'Candidate|Program History|CE Activity|Edit|Hint Error Min With Units',
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducation,
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPCandidateHistoryCreqEditLocNames>(
	spCandidateHistoryCreqEditLocs
);
